import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {contentTypeEnabledGuard} from './structure/config/content-type.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./content/splash/splash.module').then(m => m.SplashPageModule)
    },
    {
        path: 'splash',
        loadChildren: () => import('./content/splash/splash.module').then(m => m.SplashPageModule)
    },
    {
        path: 'intro',
        loadChildren: () => import('./content/intro/intro.module').then(m => m.IntroPageModule)
    },
    {
        path: 'home',
        loadChildren: () => import('./content/home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'risk-assesment/:tag',
        loadChildren: () => import('./content/risk-assesment/risk-assesment.module').then(m => m.RiskAssesmentPageModule)
    },
    {
        path: 'risk-assesment/form/:tag',
        loadChildren: () => import('./content/risk-assesment/form/form-routing.module').then(m => m.FormPageRoutingModule)
    },
    {
        path: 'risk-assesment/result/:tag',
        loadChildren: () => import('./content/risk-assesment/result/result-routing.module').then(m => m.ResultPageRoutingModule)
    },
    {
        path: 'onboarding',
        loadChildren: () => import('./content/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./content/auth/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'forgot',
        loadChildren: () => import('./content/auth/forgot/forgot.module').then(m => m.ForgotPageModule)
    },
    {
        path: 'migrated-forgot',
        loadChildren: () => import('./content/auth/migrated-forgot/migrated-forgot.module').then(m => m.MigratedForgotPageModule)
    },
    {
        path: 'register',
        loadChildren: () => import('./content/auth/register/register.module').then(m => m.RegisterPageModule)
    },
    {
        path: 'two-factor',
        loadChildren: () => import('./content/auth/two-factor/two-factor.module').then(m => m.TwoFactorPageModule)
    },
    {
        path: 'categories',
        loadChildren: () => import('./content/categories/categories.module').then(m => m.CategoriesPageModule)
    },
    {
        path: 'category/:slug',
        loadChildren: () => import('./content/category/category.module').then(m => m.CategoryPageModule)
    },
    {
        path: 'search',
        loadChildren: () => import('./content/search/search.module').then(m => m.SearchPageModule)
    },
    {
        // Kept so existing deep links and bookmarks to the old articles listing still land.
        path: 'articles/:slug',
        redirectTo: 'category/:slug',
    },
    {
        path: 'article/:slug',
        loadChildren: () => import('./content/article/article.module').then(m => m.ArticlePageModule)
    },
    {
        path: 'account',
        loadChildren: () => import('./content/account/account.module').then(m => m.MyAccountPageModule)
    },
    {
        path: 'notifications',
        loadChildren: () => import('./content/notifications/notifications.module').then(m => m.NotificationsPageModule)
    },
    {
        path: 'page/:slug',
        loadChildren: () => import('./content/page/page.module').then(m => m.PagePageModule)
    },
    {
        path: 'calendar',
        loadChildren: () => import('./content/mood-log/calendar/calendar.module').then(m => m.CalendarPageModule)
    },
    {
        path: 'add-entry',
        loadChildren: () => import('./content/mood-log/add-entry/add-entry.module').then(m => m.AddEntryPageModule)
    },
    {
        path: 'added-entry',
        loadChildren: () => import('./content/mood-log/added-entry/added-entry.module').then(m => m.AddedEntryPageModule)
    },
    {
        path: 'add-journal',
        loadChildren: () => import('./content/mood-log/add-journal/add-journal.module').then(m => m.AddJournalPageModule)
    },
    {
        path: 'journal',
        loadChildren: () => import('./content/mood-log/add-journal/add-journal.module').then(m => m.AddJournalPageModule)
    },
    {
        path: 'calendar-not-logged-in',
        loadChildren: () => import('./content/mood-log/not-logged-in/not-logged-in.module').then(m => m.NotLoggedInPageModule)
    },
    {
        path: 'guides-not-logged-in',
        loadChildren: () => import('./content/guides/not-logged-in/not-logged-in.module').then(m => m.NotLoggedInPageModule)
    },
    {
        path: 'guides',
        loadChildren: () => import('./content/guides/guides.module').then(m => m.GuidesPageModule)
    },
    {
        path: 'guide/:slug',
        loadChildren: () => import('./content/guide/guide.module').then(m => m.GuidePageModule)
    },
    {
        path: 'guide/:slug/preview',
        loadChildren: () => import('./content/guide/preview/preview.module').then(m => m.PreviewPageModule)
    },
  {
    path: 'live-incident/:slug',
    loadChildren: () => import('./content/live-incident/live-incident.module').then(m => m.LiveIncidentPageModule)
  },
    {
        // The shorts listing and short-category pages were replaced by the common
        // /category page; only the short detail page remains.
        path: 'short/:slug',
        // A shared or bookmarked link to a short goes home while the type is off.
        canActivate: [contentTypeEnabledGuard('short')],
        loadChildren: () => import('./content/short/short.module').then(m => m.ShortPageModule)
    },
    {
        path: 'directory-of-services',
        loadChildren: () => import('./content/directory-of-services/directory-of-services.module').then(m => m.DirectoryOfServicesPageModule)
    },
    {
        path: 'crisis-mode',
        loadChildren: () => import('./content/crisis-mode/crisis-mode.module').then(m => m.CrisisModePageModule)
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
